import React from 'react';
import { connect } from 'react-redux'
import {CatoroSpinner} from '../CatoroSpinner'
import {fetchSingleUsrTable, fetchSingleCupping, getUserTableCuppings, isOwner, updateCupping, deleteCupping} from '../../actions/actions'
import DisplayError from '../DisplayError'
import {Container} from 'react-bootstrap'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import CuppingScoreFrom from './CuppingsScoreForm'
import { withRouter } from 'react-router-dom';
import { FaFileExport } from 'react-icons/fa';
import ExportPreview from '../other/ExportPreview' 

class CuppingScore extends React.Component {
    state = {
        showExportPreview: false,
        exportIcon: true,
    }

    toggleExportPreview = () => {
        this.setState({
            ...this.state, 
            showExportPreview: !this.state.showExportPreview,
            exportIcon: !this.state.exportIcon
        })
    }

    componentDidMount(){
        window.scrollTo(0, 0);
        const cuppingId = window.location.pathname.replace("/score_cupping/", "")
        this.props.fetchSingleCupping(cuppingId)
        
    }

    componentDidUpdate(prevProps) {
        // Don't forget to compare props:
        if (this.props.singleCupping !== prevProps.singleCupping) {
            this.props.fetchSingleUsrTable(this.props.singleCupping.table_id)    
        }

        else if (this.props.singleTable !== prevProps.singleTable) {
            this.props.getUserTableCuppings(this.props.singleCupping.table_id)    
        }
    }

    handleDelete = () => {
        window.scrollTo(0, 0);
        this.props.deleteCupping(this.props.singleCupping.id)
        this.props.history.push(`/tables/${this.props.singleTable.id}`)
    } 

    
    cuppingScore = (cupping) => {
        window.scrollTo(0, 0);
        this.props.updateCupping(cupping, this.props.singleCupping.id)
        // setTimeout(() => this.props.history.push(`/tables/${this.props.singleTable.id}`), 1200)
    }

    renderChecks = () => {
        const singleCupping = this.props.singleCupping
        const cuppingNum = this.props.tableCuppings.findIndex( c => c.id === singleCupping.id )
        // console.log(this.props)
        
        return (
          <Container className="w3-container">
             <React.Fragment>
             <Breadcrumb>
                <Breadcrumb.Item href={`/tables/${this.props.singleTable.id}`} style={{textDecoration: "none"}}>Back to Table</Breadcrumb.Item>
                <Breadcrumb.Item active>Score Cupping</Breadcrumb.Item>
             </Breadcrumb>

                <span> <FaFileExport className="cog w3-right" style={{color: "#15aabf"}} onClick={() => this.toggleExportPreview()}></FaFileExport> </span>

                    {this.state.showExportPreview ? 
                        <ExportPreview cupping={this.props.singleCupping} name={this.props.user.name} tableName={this.props.singleTable.name} tableDate={this.props.singleTable.date} cuppingNum={cuppingNum} toggleExportPreview={this.toggleExportPreview}/> : null}


                    <CuppingScoreFrom singleCupping={this.props.singleCupping} cuppingScore={this.cuppingScore} singleTable={this.props.singleTable} cuppingNum={cuppingNum} user={this.props.user} handleDelete={this.handleDelete}/>

            </React.Fragment>
        </Container>
        )
    }


    render(){
     if (this.props.error) {
            // console.log(this.props.error_msg)
            return <DisplayError errorMsg={this.props.error_msg} />
        } 
        else if (!this.props.singleCupping || !this.props.singleTable || !this.props.tableCuppings) {
            return <CatoroSpinner/>
        } 
        else if (!isOwner(this.props.singleTable.catador_id, this.props.user.id)){
            return <DisplayError errorMsg="Please check link again and/or ensure you're authorized to view this page" />
        } 
        
        else if (this.props.singleCupping && this.props.singleTable && this.props.tableCuppings) {
        return (
            this.renderChecks()
        )  
     }

    }
}

const msp = state => {
	return {
        isLoggedIn: state.users.isLoggedIn,
        user: state.users.user,
        error: state.users.error,
        error_msg: state.users.error_msg,
        singleCupping: state.cuppings.singleCupping,
        singleTable: state.cuppings.singleTable,
        tableCuppings: state.cuppings.tableCuppings,
        // table: state.cuppings.table,
	}
  };
  
  export default connect(msp, {
    fetchSingleUsrTable, fetchSingleCupping, getUserTableCuppings, updateCupping, deleteCupping,
  })(withRouter(CuppingScore))